<template>
  <v-dialog v-model="showTechDetails" width="800" persistent>
    <v-card class="pb-4">
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-title class="primary">
          <span class="white--text">Technical Contact</span>
        </v-card-title>
        <v-card-text class="subtitle-1 pb-0 pt-3">
          <v-row>
            <v-col cols="12" class="red--text font-italic body-2"
              >*Details required for
              <span class="font-weight-bold">"Self Install"</span></v-col
            >
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Contact Firstname"
                :rules="fieldRequired ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.firstName"
                  label="Contact Firstname"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Contact Lastname"
                :rules="fieldRequired ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.lastName"
                  label="Contact Lastname"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Contact Email"
                :rules="fieldRequired ? 'required|email' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.email"
                  label="Contact Email"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Contact Number"
                :rules="fieldRequired ? 'required|phonenumber' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.number"
                  label="Contact Number"
                  maxlength="10"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="12" class="py-0">
              <ValidationProvider
                name="Shipping Address Type"
                :rules="fieldRequired ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-select
                  label="Shipping Address Type"
                  :items="shippingOptions"
                  v-model="techDetails.shippingType"
                  placeholder=" "
                  :error-messages="errors"
                  dense
                  outlined
                  autocomplete="new"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row v-if="isAlternateAddress">
            <!-- <v-col cols="12" lg="6" class="py-0" v-show="!isAlternateAddress">
              <ValidationProvider name="Shipping Address" v-slot="{ errors }">
                <v-text-field
                  v-model="techDetails.shipping.fullAddress"
                  label="Shipping Address"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col> -->
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Address Line"
                :rules="isAlternateAddress ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.shipping.addressLine"
                  label="Address Line"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Suburb"
                :rules="isAlternateAddress ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.shipping.suburb"
                  label="Suburb"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="State"
                :rules="isAlternateAddress ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="techDetails.shipping.state"
                  label="State"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" lg="6" class="py-0">
              <ValidationProvider
                name="Postcode"
                :rules="isAlternateAddress ? 'required' : ''"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model.number="techDetails.shipping.postcode"
                  label="Postcode"
                  type="number"
                  placeholder=" "
                  autocomplete="new"
                  :error-messages="errors"
                  outlined
                  dense
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="mt-4">
          <v-spacer></v-spacer>
          <v-btn
            class="primary mr-2"
            @click="updateContact()"
            :disabled="!dirty || invalid"
            >Update</v-btn
          >
          <v-btn class="primary mr-2" @click="cancelUpdate()">Cancel</v-btn>
        </v-card-actions>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TechnicalDetails",
  props: {
    showTechDetails: { type: Boolean, required: true },
    fieldRequired: { type: Boolean, required: true },
  },
  data: () => ({
    techDetails: {
      firstName: "",
      lastName: "",
      number: "",
      email: "",
      shippingType: "Same as Location Address",
      shipping: {
        fullAddress: "",
        addressLine: "",
        suburb: "",
        state: "",
        postcode: "",
      },
    },
    shippingOptions: ["Same as Location Address", "Alternate Address"],
  }),
  computed: {
    isAlternateAddress() {
      let vm = this;
      return vm.techDetails.shippingType === "Alternate Address";
    },
  },
  methods: {
    updateContact() {
      let vm = this;

      if (vm.isAlternateAddress)
        vm.techDetails.shipping.fullAddress = `${vm.techDetails.shipping.addressLine}, ${vm.techDetails.shipping.suburb} ${vm.techDetails.shipping.state} ${vm.techDetails.shipping.postcode}`;
      else {
        vm.sqResult.address.additionalParameters.forEach((x) => {
          if (x.name === "formattedAddress")
            vm.techDetails.shipping.fullAddress = x.value;
        });
      }

      vm.$emit("updateContact", vm.techDetails);
    },
    cancelUpdate() {
      let vm = this;

      vm.techDetails = {
        firstName: "",
        lastName: "",
        number: "",
        email: "",
        shippingType: "Same as Location Address",
        shipping: {
          fullAddress: "",
          addressLine: "",
          suburb: "",
          state: "",
          postcode: "",
        },
      };

      if (
        window.confirm(
          "Contact details are required. Are you sure you want to cancel?"
        ) === true
      ) {
        vm.$emit("cancelUpdate");
      }
    },
  },
};
</script>